export interface Feature {
  name: string;
  description: string;
  icon: React.ReactNode;
}

export enum PricingTier {
  Free = 'Free',
  Basic = 'Basic',
  Pro = 'Pro',
}

export enum BillingCycle {
    Monthly = 'Monthly',
    Annually = 'Annually',
}

export interface Plan {
  name: PricingTier;
  price: {
    [BillingCycle.Monthly]: string;
    [BillingCycle.Annually]: string;
  };
  description: string;
  features: string[];
  isFeatured: boolean;
}